import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/connect/app.module';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}
 
export const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] } 
]; 

enableProdMode();

platformBrowserDynamic(providers).bootstrapModule(AppModule).catch(err => console.log(err));


